
  import {Component, Prop, Vue} from 'vue-property-decorator';
  import PhoneInput from "@/components/PhoneInput.vue";
  import {IFormBuilder} from "@/modules/FormBuilder/interfaces/form-builder.interface";
  import AppSwitch from "@/components/AppSwitch.vue";


  @Component({
    components: {
      PhoneInput,
      AppSwitch,
    },
  })
  export default class FormBuilderField extends Vue {
    @Prop({ type: [String, Number, Boolean, Array] }) value!: string | number | boolean | any[];
    @Prop() field: IFormBuilder.IField;
    @Prop() invalid!: string[];

    $refs: any;
    publicPath = process.env.VUE_APP_PUBLIC_URL;
    type = IFormBuilder.FieldType;
    dateFormat = 'DD.MM.YYYY HH:mm';
    displayPassword = false;
    displayNumber = true;

    get selectValueMultiple() {
      let result = [];
      if (Array.isArray(this.value)) {
        result = this.value;
      }
      else if (typeof this.value === 'string') {
        result = this.value && this.value.length ? this.value.split(',').map(item => +item) : [];
      }
      return result;
    }
    get selectValue() { return +this.value; }

    inputAction(value) {
      let resultValue = value;
      if (this.field.prop === 'phone' && ['+7 (', '+7 '].includes(value)) resultValue = null;
      this.$emit('input', resultValue);
    }

    blurAction() {
      this.$emit('blur');
    }
  }
